import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Table, CardBox,
    DropdownButton, SearchWithAction,
    EmptyState, Page
} from '../../components'
import { retrieve } from '../../actions/organization-actions'
import { push } from '../../actions/nav-actions'
import { deleteOrganization } from '../../api'
import { copy, notify, testRegex } from '../../utils';
import Loader from '../../components/Loader';

class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: '',
            loading: false
        };
        this.renderChild = this.renderChild.bind(this);
        this.renderEmpty = this.renderEmpty.bind(this);

    }
    componentDidMount() {
        this.props.retrieve(this.props.user.token)
    }
    renderEmpty() {
        return (
            <Loader />  
        )
    }
    renderChild() {
        return (

            [
                { Header: 'Name', accessor: 'name' },
                { Header: 'Code', accessor: 'code' },
                { Header: 'Administrator', accessor: 'admin_name' },
                { Header: 'Mission Statement', accessor: 'description' },
                { Header: 'Country', accessor: 'country' },
                {
                    Header: 'Options',
                    accessor: d => d,
                    className: "no-overflow",
                    id: 'options',
                    Cell: props => (
                        <DropdownButton
                            icon="mdi mdi-account-box"
                            onActionClick={() => this.props.push(`/organizations/${props.value.code}/directory`)}
                            label="Directory">
                            <DropdownButton.Option
                                onClick={() => this.props.push(`/organizations/${props.value.code}`)}
                                icon="mdi mdi-pencil"
                                label="Edit" />
                            <DropdownButton.Option
                                onClick={() => copy(props.value.code, (text) => notify('Copy code', 'Code [' + text + '] copied!'))}
                                icon="mdi mdi-layers"
                                label="Copy code" />
                            <DropdownButton.Option
                                onClick={() => this.props.push(`/organizations/${props.value.code}/members`)}
                                icon="mdi mdi-account-plus"
                                label="Add users" />
                            <DropdownButton.Option
                                onClick={() => {
                                    let confirm = window.confirm('Really wants to delete organization ' + props.value.code + '?');
                                    if (confirm) {
                                        deleteOrganization(this.props.user.token, props.value.code)
                                            .then((organization) => this.props.retrieve(this.props.user.token))
                                            .catch((err) => notify(err.message))
                                    }
                                }}
                                icon="mdi mdi-delete"
                                label="Delete" />
                        </DropdownButton>
                    )
                }
            ]
        )
    }
    render() {
        let results = this.props.organizations.data.filter(i => testRegex(i.name, this.state.query));
        return (
            <Page title="Organizations">
                <SearchWithAction
                    action="CREATE ORGANIZATION"
                    onActionClick={() => this.props.push('/organizations/new')}
                    onChange={query => this.setState({ query })} />
                <CardBox>
                    <Table
                        id="organizations"
                        renderEmpty={!!this.props.organizations.loading ? () => <Loader /> : this.renderEmpty}
                        columns={this.renderChild()}
                        data={results} />
                </CardBox>
            </Page>
        )
    }
}


const mapStateToProps = state => ({
    user: state.authReducer.user,
    organizations: state.organizations
})

const mapDispatchToProps = dispatch => ({
    retrieve(token) {
        dispatch(retrieve(token));
    },
    push(routeName) {
        dispatch(push(routeName));
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(List);


// WEBPACK FOOTER //
// ./src/routers/Organizations/List.js